module.exports = "\n<div v-if=\"task.output\">\n    Saída V2: {{ task.output.value }}\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/javascript/components/queue/Outputs/TestV2.vue
// module id = ./node_modules/vue-html-loader/index.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/javascript/components/queue/Outputs/TestV2.vue
// module chunks = 54